<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <QTable
                    :data="result"
                    :columns="formattedColumns"
                    :hide-bottom="true"
                    :rows-per-page-options="[0]"
                    row-key="item_id"
                    :loading="isLoading"
                    class="q-table"
                >
                    <template v-slot:bottom-row>
                        <q-tr
                            v-if="result.length == 0 && !isLoading && !isError"
                        >
                            <q-td colspan="8">No records available</q-td>
                        </q-tr>
                    </template>
                    <template v-slot:header-cell="{ col }">
                        <th>
                            <strong>{{ col.label }}</strong>
                        </th>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>
<script>
import { QTable } from "quasar";
import "@/css/quasar-table.css";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
export default {
    components: {
        QTable,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("isoWeek"),
                    end: this.getEndDate("day")
                };
            }
        }
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            locale: "en-US",
            loaded: false,
            meta: "",
            result: [],
            tableHeader: [],
            dateRange: "",
            title: "Discounts Summary",
            code: "",
            params: "",
            refresh: 0,
            startOfWeek: 0
        };
    },
    mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self._getSetting().then(() => {
            self.data.start = self.getStartDate("isoWeek");
            self.data.end = self.getEndDate("day");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.data.startOfWeek = self.converToUnix(
                self.getStartDate("isoWeek")
            );
            self.dynamicPageTitle(self.title);
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", self.init);
        self.$root.$on("discount-summary:refresh", function () {
            self.refresh = 1;
            self.init();
        });
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.data.isShowDateTimeRange = false;
        this.$root.$off("report-filter-date-range:refresh", this.init);
        this.$root.$off("discount-summary:refresh");
    },
    computed: {
        formattedColumns() {
            return [
                {
                    name: "discount",
                    label: "Discount",
                    field: "discount",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "applied",
                    label: "Applied",
                    field: "applied",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "amount",
                    label: "Amount",
                    field: row => row.amount,
                    format: (val, row) => {
                        return this._toCurrency(row.amount);
                    },
                    align: "left",
                    style: "white-space: nowrap"
                }
            ];
        }
    },
    methods: {
        async init(params) {
            let self = this;
            self.loaded = false;
            self.isLoading = true;
            self.isError = false;
            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
                self.refresh = params.refresh;
                self.startOfWeek = params.startOfWeek
                    ? self.getStartDate("week").unix()
                    : 0;
            }
            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            await ReportService.getReport(CREPORT.TYPE.DISCOUNTS_SUMMARY, {
                from: self.data.from,
                to: self.data.to,
                refresh: self.refresh,
                start_of_week: self.startOfWeek
            })
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.result = res.resource.results;
                        self.tableHeader = res.resource.header;
                        self.title = res.resource.meta.title;
                        self.dynamicPageTitle(self.title);
                        self.dateRange = self.getDateRange(
                            res.resource.meta.fromDate,
                            res.resource.meta.toDate
                        );

                        if (
                            res.resource?.meta &&
                            res.resource.meta.fromDate &&
                            res.resource.meta.toDate
                        ) {
                            //    To show the filtered report date on the filter modal
                            self.data.start = moment.unix(
                                parseFloat(res.resource.meta.fromDate)
                            );
                            self.data.end = moment.unix(
                                parseFloat(res.resource.meta.toDate)
                            );

                            if (
                                Math.abs(
                                    self.data.start.diff(self.data.end, "days")
                                ) +
                                    1 >
                                30
                            ) {
                                // change the modal filter date "Date Range" to Custom
                                self.data.datePickerOptionDefault = 1;
                            }
                        }

                        self.loaded = true;
                        self.isLoading = false;
                    }
                })
                .catch(e => {
                    console.error(e.message);
                    self.isLoading = false;
                    self.isError = true;
                    this._message("Error: Unable to get the report", "danger");
                });
        }
    }
};
</script>
